"use client";

import * as React from "react";
import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";

function AlertDialog(props: React.ComponentProps<typeof AlertDialogPrimitive.Root>) {
  return <AlertDialogPrimitive.Root {...props} />;
}

function AlertDialogTrigger(props: React.ComponentProps<typeof AlertDialogPrimitive.Trigger>) {
  return <AlertDialogPrimitive.Trigger {...props} />;
}

function AlertDialogPortal(props: React.ComponentProps<typeof AlertDialogPrimitive.Portal>) {
  return <AlertDialogPrimitive.Portal {...props} />;
}

function AlertDialogOverlay(props: React.ComponentProps<typeof AlertDialogPrimitive.Overlay>) {
  return (
    <AlertDialogPrimitive.Overlay
      {...props}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 50,
        animation: "fadeIn 0.2s ease",
        ...props.style,
      }}
    />
  );
}

function AlertDialogContent(props: React.ComponentProps<typeof AlertDialogPrimitive.Content>) {
  return (
    <AlertDialogPortal>
      <AlertDialogOverlay />
      <AlertDialogPrimitive.Content
        {...props}
        data-slot="alert-dialog-content"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 60,
          display: "grid",
          gap: "1rem",
          width: "100%",
          maxWidth: "32rem",
          backgroundColor: "white",
          borderRadius: "0.5rem",
          border: "1px solid rgba(0,0,0,0.1)",
          boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
          padding: "1.5rem",
          transition: "all 0.2s ease",
          animation: "zoomIn 0.2s ease",
          ...props.style,
        }}
      />
    </AlertDialogPortal>
  );
}

function AlertDialogHeader(props: React.ComponentProps<"div">) {
  return (
    <div
      {...props}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        textAlign: "center",
        ...props.style,
      }}
    />
  );
}

function AlertDialogFooter(props: React.ComponentProps<"div">) {
  return (
    <div
      {...props}
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "0.5rem",
        marginTop: "1rem",
        alignItems: "flex-end",
        justifyContent:'flex-end',
        ...props.style,
      }}
    />
  );
}

function AlertDialogTitle(props: React.ComponentProps<typeof AlertDialogPrimitive.Title>) {
  return (
    <AlertDialogPrimitive.Title
      {...props}
      data-slot="alert-dialog-title"
      style={{
        fontSize: "1.125rem",
        fontWeight: 600,
        color: "#111827",
        ...props.style,
      }}
    />
  );
}

function AlertDialogDescription(props: React.ComponentProps<typeof AlertDialogPrimitive.Description>) {
  return (
    <AlertDialogPrimitive.Description
      {...props}
      data-slot="alert-dialog-description"
      style={{
        fontSize: "0.875rem",
        color: "#4b5563",
        ...props.style,
      }}
    />
  );
}

function AlertDialogAction(props: any) {
  return (
    <AlertDialogPrimitive.Action
    data-slot="alert-dialog-action"
    style={{
      backgroundColor:props?.bg?props?.bg: "#2563eb",
      color: "white",
      border: "none",
      borderRadius: "0.375rem",
      padding: "0.5rem 1rem",
      cursor: "pointer",
      fontSize: "0.875rem",
      fontWeight: 500,
      transition: "background-color 0.2s ease",
      alignSelf: "flex-end",
      ...props.style,
    }}
      {...props}
   
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor =props?.bg?props?.bg: "#1e40af")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor =props?.bg?props?.bg: "#2563eb")}
    />
  );
}

function AlertDialogCancel(props: React.ComponentProps<typeof AlertDialogPrimitive.Cancel>) {
  return (
    <AlertDialogPrimitive.Cancel
      {...props}
      data-slot="alert-dialog-cancel"
      style={{
        backgroundColor: "white",
        color: "#111827",
        border: "1px solid #d1d5db",
        borderRadius: "0.375rem",
        padding: "0.5rem 1rem",
        cursor: "pointer",
        fontSize: "0.875rem",
        fontWeight: 500,
        transition: "all 0.2s ease",
        alignSelf: "flex-end",
        ...props.style,
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f3f4f6")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
    />
  );
}

export {
  AlertDialog,
  AlertDialogPortal,
  AlertDialogOverlay,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
};
